import { FastTrack } from "../../../react4xp/parts/fasttrack/fasttrack"

export default (props) => <FastTrack {...props} />